(() => {
  'use strict';
  function start() {
    const root = document.querySelector('[data-clothing-display-title]');
    if (!root) return;
    let pending = false;
    const update = () => {
      pending = false;
      if (!root.isConnected) return;
      const title = root.dataset.clothingDisplayTitle;
      if (!title) return;
      const elements = [...root.querySelectorAll('.product-details h1, .view-product-title a'), ...document.querySelectorAll('#ea-sticky-cart-root .eascStickyAddToCartBar .easc-productTitle')];
      elements.forEach(element => { if (element.textContent.trim() !== title) element.textContent = title; });
    };
    update();
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(update);
    }).observe(document.body, {childList:true, subtree:true, characterData:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
